import React from "react";
import { CalendarDays } from "lucide-react";
import { Step, Field, TIMES, todayISO } from "@/pages/booking/bookingUi";

export const SlotStep = ({ form, setForm, fullSlots }) => (
  <Step n="04" title="Pick a slot" Icon={CalendarDays}>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
      <Field label="Preferred date">
        <input data-testid="booking-date" required type="date" min={todayISO()} className="ta-input" value={form.preferred_date} onChange={(e) => setForm({ ...form, preferred_date: e.target.value })} />
      </Field>
      <Field label="Preferred time">
        <select data-testid="booking-time" className="ta-input" value={form.preferred_time} onChange={(e) => setForm({ ...form, preferred_time: e.target.value })}>
          {TIMES.map((t) => {
            const full = fullSlots.includes(t);
            return (
              <option key={t} value={t} disabled={full}>
                {t}{full ? " — fully booked" : ""}
              </option>
            );
          })}
        </select>
        {fullSlots.length > 0 && (
          <p className="mt-1.5 text-[11px] font-mono text-zinc-500" data-testid="booking-full-hint">
            {fullSlots.length} slot{fullSlots.length > 1 ? "s" : ""} full on this day.
          </p>
        )}
      </Field>
    </div>
    <div className="mt-5">
      <Field label="Notes (optional)">
        <textarea data-testid="booking-notes" rows={4} className="ta-input resize-none" value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} placeholder="Anything we should know about your car?" />
      </Field>
    </div>
  </Step>
);
